export default {
    init() {
        this.bidListSidebar();
    },


    bidListSidebar(){
        $('.bid-card').on('click', function(){
            let card = $(this);
            if(card.hasClass('active')){
                card.removeClass('active');
                $('.bid-card-sidebar').removeClass('active');
            } else {
                $('.bid-card').removeClass('active');
                $('.bid-card-sidebar').removeClass('active');
                card.addClass('active');
                $('.bid-card-sidebar').addClass('active');
            }
        });
    },

}